/**
 * dashboardTemConteudo — PR 5.
 *
 * O Dashboard só existe com conteúdo: precisa ENXERGAR a tela
 * (`portal:dashboard:view`) E ter pelo menos uma seção pra mostrar (Processos
 * OU Financeiro). Sem isso a tela é só zeros, pior que não existir — parece
 * que o parceiro não tem nada.
 *
 * M10 (revisão final) — morava em `PortalLayout.tsx` (um componente React).
 * `App.tsx` importava só esta função de lá, pra decidir a ROTA `/portal/dashboard`
 * com a MESMA regra que gateia o item do MENU em `PortalLayout.tsx` — uma
 * trava só, não duas que podem discordar. Mas um predicado exportado ao lado
 * de um componente aciona o `react-refresh/only-export-components` do Vite
 * (o módulo mistura componente + não-componente, e o fast refresh não separa
 * os dois), e `App.tsx` acabava importando um módulo de COMPONENTE só pela
 * função. Aqui é puro: sem JSX, sem estado, sem efeito colateral.
 */
export function dashboardTemConteudo(has: (perm: string) => boolean): boolean {
  return (
    has("portal:dashboard:view") && (has("portal:processos:view") || has("portal:financeiro:view"))
  );
}
